var map = {
	"./0.png": "5c7a",
	"./1.png": "94d8",
	"./2.png": "74e2",
	"./3.png": "df63",
	"./4.png": "6a2c",
	"./5.png": "2f91",
	"./6.png": "033d",
	"./7.png": "5c81",
	"./8.png": "af4e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db34";